import { PremiumSection } from '../shared/PremiumSection'
import { PremiumHeading } from '../shared/PremiumHeading'
import { YOUTUBE_URL } from '@/shared/lib/constants'

/**
 * Real comments from the YouTube channel. Quotes are verbatim — do not trim,
 * tidy or re-punctuate them. They are attributed to real people.
 */
const TESTIMONIALS = [
  {
    quote:
      'I am glad I came across your channel. Your wisdom is much appreciated! I am learning a lot more than people just telling me what the newest AI tool is or showing off their latest work without really ever even telling you how to do anything.',
    author: 'Charles',
    context: 'YouTube subscriber',
  },
  {
    quote:
      "There's so much uncertainty and AI hype out there that it's difficult to find someone I trust to explore, distill, and present things in a clear way. I look forward to more!",
    author: 'Joseph',
    context: 'YouTube subscriber',
  },
  {
    quote:
      "Great content! Just getting my feet wet with AI coding. I found this extremely helpful for understanding how things actually work. I'd love to see more on coding small projects with open source models.",
    author: 'Nate',
    context: 'YouTube subscriber',
  },
]

export function TestimonialsSection() {
  return (
    <PremiumSection containerClassName="max-w-4xl">
      <PremiumHeading as="h2">From the channel</PremiumHeading>
      <p className="mb-10 max-w-2xl leading-relaxed text-[#c3ccc7]">
        These are comments on the videos, not testimonials from paid sessions —
        the Workflow Review is new.{' '}
        <a
          href={YOUTUBE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#80cca5] underline underline-offset-4 hover:text-[#6bb890]"
        >
          Judge the teaching for yourself first.
        </a>
      </p>

      <div className="grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((testimonial) => (
          <figure
            key={testimonial.author}
            className="flex flex-col rounded-xl border border-[#232a26] bg-[#141817] p-6"
          >
            <blockquote className="mb-5 flex-1 leading-relaxed text-[#c3ccc7]">
              {testimonial.quote}
            </blockquote>
            <figcaption className="text-sm">
              <span className="font-semibold text-[#f0f3f1]">
                {testimonial.author}
              </span>
              <span className="text-[#8b958f]"> · {testimonial.context}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </PremiumSection>
  )
}
